import { useTranslation } from 'react-i18next';

import { formatRelativeTime } from '../services/timeFormat';

export const useFormatRelativeTime = (datetime: string): string | null => {
  const { t } = useTranslation();

  if (!datetime) {
    return null;
  }

  const { value, unit } = formatRelativeTime(datetime);

  if (unit === 'date') {
    return String(value);
  }

  return t('common.time-ago', { time: `${value}${unit}` });
};
